/**
 * Jetons de design — source unique de vérité pour les couleurs, polices et
 * métriques de l'admin.
 *
 * Les noms et les valeurs sont repris tels quels de l'application mobile
 * (liencitoyen-app/src/theme/index.js) pour que les deux produits partagent
 * le même vocabulaire. Toute nouvelle couleur doit d'abord être cherchée ici.
 */

/** Palette de l'app mobile (`couleurs`). */
export const couleurs = {
    Jaune: "#FFB800",
    JauneLigne: "#FFCB46",
    /** Bleu principal — unifié avec l'app mobile depuis le 22 septembre 2026 (était #00004F). */
    BleuMarin: "#243D63",
    BleuClair: "#44B2CC",
    Fond: "#ECF0F3",
    FondHeader: "#dbe0e6",
    Blanc: "#FFFFFF",
    Texte: "#333333",
    GrisTexte: "#A0A0A0",
    GrisFonce: "#7c8ba1",
    GrisMoyen: "#BDBDBD",
    GrisTresClair: "#E4E7E8",
    GrisBordure: "#E5E7EB",
    PresqueBlanc: "#F7F8FA",
    Rouge: "#EB5757",
    RougeClair: "#F1D5D7",
    RougeFonce: "#A92323",
    Vert: "#6FCF97",
    VertClair: "#D9EDE4",
    Orange: "#F39225",
    OrangeClair: "#F3E1CD",
    Violet: "#9553B2",
    VioletClair: "#E0D5E9",
    JauneClair: "#FFF4D7",
    CyanClair: "#D7EBEE",
    Brun: "#924C09",
} as const;

/**
 * Couleurs propres à l'admin, sans équivalent dans l'app mobile.
 * À réduire au fil du temps en les rapprochant de la palette ci-dessus.
 */
export const couleursAdmin = {
    /** Fond gris des écrans d'administration (--lightGray). */
    FondPage: "#EFF2F3",
    /** Bande du haut de l'admin (titre, nom de l'utilisateur, déconnexion). */
    FondBandeHaut: "#E4EBED",
    /** Bordure standard : cartes `.blocks`, cartes de répéteur, champs. */
    BordureCarte: "#D6D8DB",
    /** Texte secondaire discret (compteurs, mentions « aucun »). */
    TexteDoux: "#8a94a0",
} as const;

/**
 * Familles de polices. L'admin déclare une famille par graisse
 * (voir assets/scss/typography/_fonts.scss) : le gras passe donc par
 * `fontFamily`, pas seulement par `fontWeight`.
 */
export const polices = {
    base: '"Nunito", "Nunito Sans", sans-serif',
    gras: '"Nunito Bold", "Nunito", "Nunito Sans", sans-serif',
    extraGras: '"Nunito Extrabold", "Nunito", "Nunito Sans", sans-serif',
} as const;

/** Métriques des champs de formulaire — `stylesChamps` de l'app mobile. */
export const champ = {
    hauteur: 50,
    rayon: 25,
    paddingHorizontal: 20,
    paddingVertical: 13,
    margeBas: 15,
    tailleTexte: 16,
} as const;
